import AuthActionTypes from 'store/modules/auth/constants';
import { ApplicationActions } from 'store/types';

import ActionTypes from './constants';
import { BackOfficeDeviceMapPointsState } from './types';

export const initialState: BackOfficeDeviceMapPointsState = { data: [] };

export default function backOfficeDeviceMapPointsReducer(
  state: BackOfficeDeviceMapPointsState = initialState,
  action: ApplicationActions
): BackOfficeDeviceMapPointsState {
  switch (action.type) {
    case ActionTypes.SET_BACK_OFFICE_DEVICE_MAP_POINTS:
      return action.payload;

    case AuthActionTypes.LOGOUT:
      return initialState;
    default:
      return state;
  }
}
